export const fireRequestTypes = {
  GET: 'GET',
  SUBSCRIBE: 'SUBSCRIBE',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  PUSH: 'PUSH',
  SET: 'SET',
  UPDATE: 'UPDATE',
  REMOVE: 'REMOVE',
};
